module.exports = __webpack_public_path__ + "assets/img/shanghai.6a06f637.png";